import { render, staticRenderFns } from "./Bellhop.vue?vue&type=template&id=297fb889&scoped=true&"
import script from "./Bellhop.vue?vue&type=script&lang=js&"
export * from "./Bellhop.vue?vue&type=script&lang=js&"
import style0 from "./Bellhop.vue?vue&type=style&index=0&id=297fb889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fb889",
  null
  
)

export default component.exports